import uniqueId from 'lodash/uniqueId';
import {
  MobileTableContainer,
  StyledTable,
  TableCell,
  TableHead,
  TableRow,
} from './Table.styles';
import { createElement } from 'react';

/**
 * every <td> or <th>
 * @param {Object} props
 * @param {StyledCellType} props.styledElement (TableCell or TableHead)
 * @param {string} props.cellContent
 * @returns {React.ReactElement}
 */
export const renderTableCell = ({ cellContent, styledElement }) =>
  createElement(styledElement, { key: uniqueId('cell') }, cellContent);

/**
 * every <tr> for desktop
 * @param {Object} props
 * @param {StyledCellType} props.styledElement (TableCell or TableHead)
 * @param {TableRowContentType} props.rowContent
 * @param {string} props.dataId
 * @returns {React.ReactElement}
 */
export const renderDesktopRow = ({ dataId, rowContent, styledElement }) => (
  <TableRow key={uniqueId('desktopTr')} data-id={`${dataId}-row`}>
    {rowContent.map((cellContent) =>
      renderTableCell({ styledElement, cellContent }),
    )}
  </TableRow>
);

/**
 * every <tr> for mobile table
 * @param {Object} props
 * @param {string} props.headContent
 * @param {string} props.bodyContent
 * @param {string} props.key
 * @returns {React.ReactElement}
 */
export const renderMobileRow = ({ headContent, bodyContent, key }) => (
  <TableRow key={key}>
    <TableHead>{headContent}</TableHead>
    <TableCell>{bodyContent}</TableCell>
  </TableRow>
);

/**
 * every single <table> from renderMobileTables
 * @param {Object} props
 * @param {TableRowContentType} props.tableHead
 * @param {TableRowContentType} props.tableContent
 * @param {string} props.key
 * @returns {React.ReactElement}
 */
export const renderSingleMobileTable = ({ tableHead, tableContent, key }) => (
  <StyledTable key={key} data-id="table-container-mobile">
    <tbody>
      {tableContent.map((content, index) =>
        renderMobileRow({
          headContent: tableHead[index],
          bodyContent: content,
          key: uniqueId('xsTableRow'),
        }),
      )}
    </tbody>
  </StyledTable>
);

/**
 * Renders multiple <table> for mobile. Each table has a header and a single column
 * @type {TableProps}
 * @returns {React.ReactElement}
 */
export const renderMobileTables = ({ tableHead, tableBody, dataId }) => (
  <MobileTableContainer data-id={`${dataId}-container-mobile`}>
    {tableBody.map((tableContent) =>
      renderSingleMobileTable({
        tableHead,
        tableContent,
        key: uniqueId('xsTable'),
      }),
    )}
  </MobileTableContainer>
);

/**
 * Renders a <table> for desktop with as many columns as necessary
 * @type {TableProps}
 * @returns {React.ReactElement}
 */
export const renderDesktopTable = ({ tableHead, tableBody, dataId }) => (
  <StyledTable data-id={`${dataId}-container-desktop`}>
    <tbody>
      {renderDesktopRow({
        styledElement: TableHead,
        rowContent: tableHead,
        dataId,
      })}
      {tableBody.map((rowContent) =>
        renderDesktopRow({ styledElement: TableCell, rowContent, dataId }),
      )}
    </tbody>
  </StyledTable>
);
